/**
 * ============================================================================
 * WBR API — RTK Query endpoint for getWeekNumbers.
 * ============================================================================
 *
 * LAYER: cache policy. Transport lives in accessors/GetWeekNumbersApi.
 * The week list changes weekly — cache for the whole session.
 */

import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import { GetWeekNumbersApi } from 'src/accessors/GetWeekNumbersApi';
import { ReportingApiError } from 'src/accessors/ReportingApiClient';
import { GetWeekNumbersResponse } from 'src/types/weekNumbersApi.types';

export type { GetWeekNumbersResponse } from 'src/types/weekNumbersApi.types';

export const weekNumbersApi = createApi({
  reducerPath: 'weekNumbersApi',
  baseQuery: fakeBaseQuery<{ status: number; data: unknown }>(),
  keepUnusedDataFor: Infinity,
  endpoints: (builder) => ({
    getWeekNumbers: builder.query<GetWeekNumbersResponse, void>({
      queryFn: async () => {
        try {
          return { data: await GetWeekNumbersApi.getWeekNumbers() };
        } catch (error) {
          if (error instanceof ReportingApiError) {
            return { error: { status: error.status, data: error.body ?? error.errorCode } };
          }
          return { error: { status: 0, data: String(error) } };
        }
      },
    }),
  }),
});

export function useGetWeekNumbersQuery() {
  return weekNumbersApi.useGetWeekNumbersQuery();
}
